import ReactGA4 from 'react-ga4';

export const initGA = () => {
  ReactGA4.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID);
};

// Updated pageview tracking for GA4
export const logPageView = () => {
  ReactGA4.send("page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname
  });
};

// Updated event tracking for GA4
export const logEvent = (name, params = {}) => {
  ReactGA4.event(name, params);
};

// Session tracking
let sessionStartTime = Date.now();

export const trackSessionTime = () => {
  const sessionDuration = Math.round((Date.now() - sessionStartTime) / 1000);
  logEvent("session_duration", {
    duration_seconds: sessionDuration
  });
};

// Enhanced engagement tracking
export const trackEngagement = () => {
  let lastScrollDepth = 0;
  
  window.addEventListener('scroll', () => {
    const scrollDepth = Math.round((window.scrollY + window.innerHeight) / 
      document.documentElement.scrollHeight * 100);
    
    if (scrollDepth > lastScrollDepth && [25, 50, 75, 90].includes(scrollDepth)) {
      logEvent("scroll_depth", {
        depth_percentage: scrollDepth
      });
      lastScrollDepth = scrollDepth;
    }
  });
};

// Add session tracking to window events
window.addEventListener('beforeunload', () => {
  trackSessionTime();
});

// Add more detailed event tracking
export const trackUserEngagement = () => {
  // Track scroll depth
  window.addEventListener('scroll', () => {
    const scrollDepth = Math.round((window.scrollY + window.innerHeight) / 
      document.documentElement.scrollHeight * 100);
    
    if ([25, 50, 75, 90].includes(scrollDepth)) {
      logEvent("scroll_depth_reached", {
        depth: scrollDepth,
        page_url: window.location.pathname
      });
    }
  });

  // Track time on page
  const startTime = Date.now();
  window.addEventListener('beforeunload', () => {
    const timeSpent = Math.round((Date.now() - startTime) / 1000);
    logEvent("time_on_page", {
      duration_seconds: timeSpent,
      page_url: window.location.pathname
    });
  });
}; 